module.exports = __webpack_public_path__ + "static/media/03_2.00804426.png";